import { StepConfig } from '../../../../shared/types/step-config.type';

import {
    BillingAdjustmentIssueType,
    LargeInstrumentWarehouseIssueType,
    EskerOrderIssueType,
    InvoiceIssueTypeDomestic,
    DocumentationIssueType,
    DeliveryIssueTypeInternational,
    DeliveryIssueTypeDomestic,
    TemperatureIssueType,
    ProductDatingUponReceiptIssueTypeInternational,
    ProductDatingUponReceiptIssueTypeDomestic,
    OrderEntryIssueTypeDomestic,
    NatureOfComplaintInternational,
    NatureOfComplaintDomestic,
    FormType,
    OrderEntryIssueTypeInternational
} from '@cod-monorepo/interfaces';

export const AffectedItemsStepConfig: StepConfig = {
    type: FormType.AFFECTED_ITEMS
};

export const domesticMapping = {
    [NatureOfComplaintDomestic.ORDER_ENTRY]: {
        selectLabel: 'Select your Order Entry Issue Type',
        selectPlaceholder: 'Missing Items / Lines',
        items: Object.values(OrderEntryIssueTypeDomestic),
        formControlName: 'issueType',
        form: 'orderEntryDomestic'
    },
    [NatureOfComplaintDomestic.PRODUCT_DATING]: {
        selectLabel: 'Product Dating upon Receipt',
        selectPlaceholder: 'Issue',
        items: Object.values(ProductDatingUponReceiptIssueTypeDomestic),
        formControlName: 'issueType',
        form: 'productDatingDomestic'
    },
    [NatureOfComplaintDomestic.PRODUCT_TEMPERATURE]: {
        selectLabel: 'Product Temperature upon Receipt',
        selectPlaceholder: 'Issue',
        items: Object.values(TemperatureIssueType),
        hiddenInCreation: [
            TemperatureIssueType.OUTSIDE_OF_EXPECTED_TEMPERATURE,
            TemperatureIssueType.QUESTIONABLE_STABILITY
        ],
        formControlName: 'issueType',
        form: 'productTemperatureDomestic'
    },
    [NatureOfComplaintDomestic.DELIVERY]: {
        selectLabel: 'Delivery Error Type',
        selectPlaceholder: 'Issue',
        items: Object.values(DeliveryIssueTypeDomestic),
        formControlName: 'issueType',
        form: 'deliveryErrorDomestic'
    },
    [NatureOfComplaintDomestic.INVOICE_ERROR]: {
        selectLabel: 'Invoice Error Type',
        selectPlaceholder: 'Issue',
        items: Object.values(InvoiceIssueTypeDomestic),
        formControlName: 'invoiceErrorType',
        form: 'invoiceErrorDomestic'
    },
    [NatureOfComplaintDomestic.BILLING_ADJUSTMENT]: {
        selectLabel: 'Billing Adjustment Type',
        selectPlaceholder: 'Issue',
        items: Object.values(BillingAdjustmentIssueType),
        formControlName: 'issueType',
        form: 'billingAdjustmentDomestic'
    },
    [NatureOfComplaintDomestic.ESKER]: {
        selectLabel: 'Esker Discrepancy Type',
        selectPlaceholder: 'Issue',
        items: Object.values(EskerOrderIssueType),
        formControlName: 'issueType',
        form: 'eskerDiscrepancyDomestic'
    },
    [NatureOfComplaintDomestic.LARGE_INSTRUMENT_WAREHOUSE]: {
        selectLabel: 'Large Instrument Warehouse Discrepancy Type',
        selectPlaceholder: 'Issue',
        items: Object.values(LargeInstrumentWarehouseIssueType),
        formControlName: 'issueType',
        form: 'largeInstrumentWarehouseDiscrepancy'
    }
} as {
    [key in NatureOfComplaintDomestic]: {
        selectLabel: string;
        selectPlaceholder: string;
        items: string[];
        hiddenInCreation?: string[];
        formControlName: string;
        form: string;
    };
};

export const internationalMapping = {
    [NatureOfComplaintInternational.ORDER_ENTRY]: {
        selectLabel: 'Select your Order Entry Issue Type',
        selectPlaceholder: 'Missing Items / Lines',
        items: Object.values(OrderEntryIssueTypeInternational),
        formControlName: 'issueType',
        form: 'orderEntryInternational'
    },
    [NatureOfComplaintInternational.PRODUCT_DATING]: {
        selectLabel: 'Product Dating upon Receipt',
        selectPlaceholder: 'Issue',
        items: Object.values(ProductDatingUponReceiptIssueTypeInternational),
        formControlName: 'issueType',
        form: 'productDatingInternational'
    },
    [NatureOfComplaintInternational.PRODUCT_TEMPERATURE]: {
        selectLabel: 'Product Temperature upon Receipt',
        selectPlaceholder: 'Issue',
        items: Object.values(TemperatureIssueType),
        hiddenInCreation: [TemperatureIssueType.QUESTIONABLE_STABILITY],
        formControlName: 'issueType',
        form: 'productTemperatureInternational'
    },
    [NatureOfComplaintInternational.DELIVERY]: {
        selectLabel: 'Delivery Error Type',
        selectPlaceholder: 'Issue',
        items: Object.values(DeliveryIssueTypeInternational),
        formControlName: 'issueType',
        form: 'deliveryErrorInternational'
    },
    [NatureOfComplaintInternational.DOCUMENTATION]: {
        selectLabel: 'Documentation Issue Type',
        selectPlaceholder: 'Issue',
        items: Object.values(DocumentationIssueType),
        formControlName: 'issueType',
        form: 'documentationInternational'
    }
} as {
    [key in NatureOfComplaintInternational]: {
        selectLabel: string;
        selectPlaceholder: string;
        items: string[];
        hiddenInCreation?: string[];
        formControlName: string;
        form: string;
    };
};
